import { DesiredSettingValueKind } from '@crossnokaye/typescript-sdk/models/components';

import { RefValueKind } from '@repo/sdk/models/components';

export const castSettingsValue = (value: any, kind: RefValueKind | undefined) => {
  switch (kind) {
    case RefValueKind.Number:
      return Number(value);
    case RefValueKind.Boolean:
      if (typeof value === 'boolean') return value;
      if (typeof value === 'string') return value.toLowerCase() === 'true';
      return Boolean(value);
    case RefValueKind.Enum:
      return String(value);
    case RefValueKind.String:
      return String(value);
    case RefValueKind.Schedule:
    case RefValueKind.Sequence:
    default:
      return value;
  }
};

export const getDesiredSettingValueKind = (
  valueKind: RefValueKind | undefined
): DesiredSettingValueKind => {
  switch (valueKind) {
    case RefValueKind.Boolean:
      return DesiredSettingValueKind.Bool;
    case RefValueKind.Number:
      return DesiredSettingValueKind.Number;
    case RefValueKind.Enum:
      return DesiredSettingValueKind.Enum;
    case RefValueKind.Schedule:
      return DesiredSettingValueKind.Schedule;
    case RefValueKind.Sequence:
      return DesiredSettingValueKind.Sequence;
    case RefValueKind.String:
    default:
      return DesiredSettingValueKind.Enum;
  }
};
